/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ColumnsType, type ColumnType, type ColumnVariations } from '@Types/Blocks/Columns';
import type { ContainerTypeEnums, PositionsAlignement } from '@Types/Shared/Common';
import type { ContextKey, Options } from '@Types/Shared/Options';

import { useContext, useEffect, useState, type ComponentProps } from 'react';

import defu from 'defu';
import _ from 'lodash';

import { MinosContext } from '@Shared/Context';

import { ColumnsStyle } from '@/views/Shared/GlobalStyles/GlobalStyles';

import { fetchImageWithId } from '../../_lib/getImageUrl';
import Block from './Block';

declare const minosOptions: any;

type ColumnRegister = {
	block: ColumnsType;
	variant: ColumnVariations;
	containerType: ContainerTypeEnums;
	headingAlign: PositionsAlignement;
	cardType: ContainerTypeEnums;
	context?: ContextKey;
};

export default function Register({
	block,
	variant = 'classic',
	containerType = 'wide',
	headingAlign = 'center',
	cardType = 'block',
	context = 'front',
}: ColumnRegister) {
	const { id, title, description, titleFormat, columns, perRow = '3', composition } = block;

	const MinosOptions: Options =
		context === 'front' ? useContext(MinosContext) : JSON.parse(minosOptions);
	const [isLoading, setLoading] = useState(true);
	const [columnsWithImage, setColumnsWithImage] = useState<ColumnType[]>();

	type FrontWPImage2 = {
		url?: string;
		alt?: string;
		parentId?: string;
	};

	useEffect(() => {
		const imagesPromises: Promise<FrontWPImage2>[] = [];
		if (columns) {
			columns.forEach(async (column) => {
				if (column.image) {
					imagesPromises.push(fetchImageWithId(column.image as any, 'large'));
				}
			});
		}

		Promise.all(imagesPromises).then((result) => {
			if (columns) {
				columns.forEach((column) => {
					if (column.image) {
						column.imageObj = _.find(result, { id: column.image }) as any;
					}
				});
			}
			setColumnsWithImage(columns);
			setLoading(false);
		});
	}, [columns]);

	let propsBlock: ComponentProps<typeof Block> = {
		id: id ? id : '',
		title: title,
		description: description,
		titleFormat: titleFormat,
		columns: columnsWithImage ? columnsWithImage : [],
		perRow: perRow,
		headingAlign: headingAlign,
		containerType: containerType,
		variant: variant,
		cardType: cardType,
		contentFontFormats: block.contentFontFormats,
		ctasStyle: MinosOptions.blocks.column.default.ctasStyle,
		placement: block.placement,
		sectionDecoration: MinosOptions.layout.sectionDecoration,
	};

	if (composition && composition != 'none') {
		const compoOptions = _.find(MinosOptions.blocks.column.compositions, { id: composition });
		if (compoOptions) {
			propsBlock = defu(compoOptions as ComponentProps<typeof Block>, propsBlock);
			propsBlock.style = ColumnsStyle(compoOptions);
		}
	}

	return <>{!isLoading && <Block {...propsBlock} />}</>;
}
